










































// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, SortDirection, Hub } from 'aws-amplify'
import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import Draggable from 'vuedraggable'
import { Info } from '../models/index'
import {
  IInfo,
} from '@/graphql/info/interfaces/infos'
import { GenerateLocaleDict } from '@/lib/Locale'
import { mutateSnackbar } from '@/store/snackbar'
import { query as tenant } from '@/store/tenant'
import { HubEvents } from '@/amplify'

@Component<DistrictInfoView>({
  components: {
    Draggable,
    AddDialog,
    ConfirmDialog
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('infos.title')
    }
  },
  apollo: {
    tenant,
  },
})
export default class DistrictInfoView extends Vue {
  infos = []
  infosSubscription = null  
  isLoading = true

  subscribeToInfos() {
    if (!this.tenant) return;
    this.infosSubscription !== null && this.infosSubscription.unsubscribe()
    this.infosSubscription = DataStore.observeQuery(
      Info,
      p => p.and(p => [
        p.tenant.eq(this.tenant.id),
        p.districtID.eq(this.districtId),
      ]),
      {
        sort: s => s.sortPosition(SortDirection.ASCENDING)
      }
    ).subscribe(({ items }) => {
      this.infos = Array.from(items)
      setTimeout(() => {
        this.isLoading = false
      }, 250)
    })
  }

  created() {
    this.subscribeToInfos()
  }

  destroyed() {
    this.infosSubscription?.unsubscribe()
  }

  @Watch('tenant')
  async recreate() {
    this.subscribeToInfos();
  }

  @Watch('districtId')
  async fetchInfos() {
    this.subscribeToInfos()
  }

  get districtId() {
    return this.$route.params.districtId
  }

  dispatchUpdateEventToHub(event) {
    Hub.dispatch('ListEdit', {
      event,
      data: {
        model: 'Info',
      }
    })
  }

  async addInfo(title: string) {
    try {
      await DataStore.save(
        new Info({
          title: GenerateLocaleDict({ de: title }),
          sortPosition: this.infos.length,
          content: GenerateLocaleDict(),
          color: '#e2e2e2',
          tenant: this.tenant?.id,
          districtInfosId: this.districtId,
          districtID: this.districtId,
        })
      )
      mutateSnackbar(
        { text: String(`Seite erstellt.`), color: `success` },
        this.$apollo
      )
    } catch(err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
  }

  async deleteInfo(info: IInfo) {
    try {
      await DataStore.delete(Info, item => item.id.eq(info.id))
      mutateSnackbar(
        { text: String(`Infoseite gelöscht.`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
  }

  async saveOrder() {
    if (!this.infos || this.infos.length <= 0) return
    this.isLoading = true
    this.infosSubscription.unsubscribe()
    for (const [index, page] of this.infos.entries()) {
      await DataStore.save(
        Info.copyOf(page, updated => {
          updated.sortPosition = index
          updated.districtID = this.districtId
        })
      )
    }
    this.dispatchUpdateEventToHub(HubEvents.orderSave)
    setTimeout(() => {
      this.subscribeToInfos()
      this.isLoading = false
    }, 250)
  }
}
